import { createContext, useContext, useEffect, useState } from "react";
import api from "../lib/api";

const BestSellerContext = createContext({ ids: new Set() });

export const BestSellerProvider = ({ children }) => {
  const [ids, setIds] = useState(new Set());

  useEffect(() => {
    api
      .get("/products/bestseller-ids", { params: { limit: 24 } })
      .then((r) => setIds(new Set(r.data?.ids || [])))
      .catch(() => setIds(new Set()));
  }, []);

  return (
    <BestSellerContext.Provider value={{ ids }}>
      {children}
    </BestSellerContext.Provider>
  );
};

export const useBestSellerIds = () => useContext(BestSellerContext).ids;
